import React from 'react';
import { Union } from '../Wrapper';
import Components from '..';
import { Route, Switch } from 'react-router-dom';
import { TrainingContentType } from '../../../lib/landingPage';
import { TRAINING_URL } from '../../../lib/landingPage/training';
import Styles from './TrainingContentContainer.module.less';
import { classes } from '../../../lib';

export type TrainingContentContainerProps = {
    trainingContents: TrainingContentType[];
};

export const TrainingContentContainer = ({
    trainingContents,
}: TrainingContentContainerProps) => {
    return (
        <div className="vertical">
            <div className={classes('d-p32 mt-p16', Styles.container)}>
                <Switch>
                    {trainingContents.map(p => (
                        <Route
                            exact
                            path={`${TRAINING_URL()}/${p.slug.current}`}
                            key={p.slug.current}>
                            <Union
                                key={p.slug.current}
                                value={p}
                                components={Components}
                            />
                        </Route>
                    ))}
                    <Route>
                        <h4>
                            Página não encontrada. Por favor selecione um tópico
                            no menu à esquerda.
                        </h4>
                    </Route>
                </Switch>
            </div>
        </div>
    );
};
